import component from './ru-RU/component';
import globalHeader from './ru-RU/globalHeader';
import menu from './ru-RU/menu';
import pages from './ru-RU/pages';
import pwa from './ru-RU/pwa';
import settingDrawer from './ru-RU/settingDrawer';
import settings from './ru-RU/settings';
import fixOverlay from './ru-RU/fix_overlay';
import fixOpenapi from './ru-RU/fix_openapi';
import fixAdminMisc from './ru-RU/fix_adminmisc';
import fixBilling from './ru-RU/fix_billing';
import fixComponents from './ru-RU/fix_components';
import fixConsoleMisc from './ru-RU/fix_consolemisc';
import fixGap from './ru-RU/fix_gap';
import fixSystemconfig from './ru-RU/fix_systemconfig';
import fixTenant from './ru-RU/fix_tenant';
import fixVoiceClone from './ru-RU/fix_voiceclone';
import fixTodo from './ru-RU/fix_todo';
import fixLedger from './ru-RU/fix_ledger';


export default {
  'navBar.lang': '���٧���',
  'layout.user.link.help': '����ާ���',
  'layout.user.link.privacy': '����ߧ�ڧէ֧ߧ�ڧѧݧ�ߧ����',
  'layout.user.link.terms': '����ݧ�ӧڧ�',
  'app.preview.down.block': '���ܧѧ�ѧ�� ���� ����ѧߧڧ�� �� �ݧ�ܧѧݧ�ߧ��� ����֧ܧ�',
  'app.welcome.link.fetch-blocks': '����ݧ��ڧ�� �ӧ�� �ҧݧ�ܧ�',
  'app.welcome.link.block-list': '���� ���ߧ�ӧ� block-��ѧ٧�ѧҧ��ܧ� �ҧ������ ���٧էѧۧ�� ���ѧߧէѧ��ߧ��� ����ѧߧڧ��',
  ...fixConsoleMisc,
  ...fixComponents,
  ...fixAdminMisc,
  ...fixBilling,
  ...fixTenant,
  ...fixVoiceClone,
  ...fixGap,
  ...fixSystemconfig,
  ...fixOpenapi,
  ...fixTodo,
  ...fixLedger,
};
